import { Play } from "lucide-react";
import { MOOD_META } from "../lib/moods";
import { getDailySuggestions } from "../lib/daily";

const cfgLabel = (cfg) => {
  const a = MOOD_META[cfg.mood]?.name;
  const b = cfg.mood2 ? ` × ${MOOD_META[cfg.mood2]?.name}` : "";
  return `${a}${b} · ${cfg.duration_minutes} min`;
};

const bg = (cfg) => {
  const c1 = MOOD_META[cfg.mood]?.color;
  const c2 = cfg.mood2 ? MOOD_META[cfg.mood2]?.color : "#3a0a22";
  return `linear-gradient(135deg, ${c1} 0%, ${c2} 100%)`;
};

export default function MoodOfDay({ onLaunch, disabled }) {
  const [hero, ...alts] = getDailySuggestions();
  return (
    <section data-testid="mood-of-day" className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 relative rounded-lg overflow-hidden p-6 flex items-end min-h-[200px]" style={{ background: bg(hero.cfg) }}>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        <div className="relative flex-1">
          <div className="text-xs font-bold uppercase tracking-widest text-white/90">Mood du jour</div>
          <div data-testid="mood-of-day-title" className="font-black text-3xl md:text-4xl tracking-tight mt-1">{hero.title}</div>
          <div className="text-sm text-white/80 mt-1">{hero.tagline}</div>
          <div className="text-xs text-white/70 mt-2 font-semibold">{cfgLabel(hero.cfg)}</div>
        </div>
        <button
          data-testid="mood-of-day-launch"
          disabled={disabled}
          onClick={() => onLaunch(hero.cfg)}
          className="relative sp-play-btn h-14 w-14 rounded-full flex items-center justify-center shadow-2xl disabled:opacity-40"
          title="Lancer"
        >
          <Play className="h-6 w-6 ml-0.5" fill="black" />
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {alts.map((s, i) => (
          <button
            key={s.title}
            data-testid={`daily-alt-${i}`}
            disabled={disabled}
            onClick={() => onLaunch(s.cfg)}
            className="group sp-card rounded-lg flex items-center gap-4 overflow-hidden text-left pr-4 flex-1 disabled:opacity-40"
          >
            <div className="h-full min-h-[80px] w-20 shrink-0" style={{ background: bg(s.cfg) }} />
            <div className="min-w-0 flex-1 py-3">
              <div className="font-extrabold truncate">{s.title}</div>
              <div className="text-xs text-[#B3B3B3] truncate">{cfgLabel(s.cfg)}</div>
            </div>
            <div className="h-10 w-10 rounded-full bg-[#FF2E93] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
              <Play className="h-4 w-4 text-black ml-0.5" fill="black" />
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
